import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const queries = buildGraphqlQuery(
  'Customer',
  `_id
  profile {
    _id
    name
    email
    picture
  }
  
`
)
